<template>
    <h1>JellyGo Feedback Form</h1>
    <div class="feedback-form">
      <form @submit.prevent="submitFeedback">
        <div class="form-group">
          <label for="name">Name:</label>
          <input type="text" id="name" v-model="feedback.name" required>
        </div>
  
        <div class="form-group">
          <label for="email">Email:</label>
          <input type="email" id="email" v-model="feedback.email" required>
        </div>
  
        <div class="form-group">
          <label for="comment">Comment:</label>
          <textarea id="comment" v-model="feedback.comment" required></textarea>
        </div>
  
        <button type="submit">Submit Feedback</button>
      </form>
    </div>
  </template>
  
  <script>
  export default {
    name: 'FeedbackForm',
    data() {
      return {
        feedback: {
          name: '',
          email: '',
          comment: '',
        },
      };
    },
    methods: {
      submitFeedback() {
        // Here you would typically send the feedback to a server
        console.log('Feedback submitted:', this.feedback);
  
        // Reset the form after submission
        this.feedback = { name: '', email: '', comment: '' };
      },
    },
  };
  </script>
  
  <style>
    .feedback-form{
        width: 50%;
    }

  .form-group {
    margin-bottom: 15px;
  }
  
  .form-group label {
    display: block;
  }
  
  .form-group input,
  .form-group textarea {
    width: 100%;
    padding: 8px;
    margin-top: 5px;
  }
  
  button {
    padding: 10px 20px;
    cursor: pointer;
  }
  </style>
  